import { useEffect, useState } from 'react'

export const INITIAL_SUBMIT_COUNTDOWN_SECONDS = 3
export const SUBMIT_COUNTDOWN_INTERVAL_MS = 1000

/**
 * useSubmitCountdown — 管理授权页提交按钮的短暂禁用倒计时。
 * 该状态只决定页面交互何时解锁，不能依赖设备 UA，避免桌面模式或特殊 WebView 永久禁用按钮。
 * @param {boolean} paused 某些渠道使用独立提交规则时暂停本倒计时
 * @returns {number} 当前剩余秒数，归零后允许提交
 */
const useSubmitCountdown = (paused = false): number => {
  const [countdownTime, setCountdownTime] = useState(INITIAL_SUBMIT_COUNTDOWN_SECONDS)

  useEffect(() => {
    if (paused || countdownTime <= 0) {
      return undefined
    }
    const timer = window.setTimeout(() => {
      setCountdownTime(current => current - 1)
    }, SUBMIT_COUNTDOWN_INTERVAL_MS)
    return () => window.clearTimeout(timer)
  }, [countdownTime, paused])

  return countdownTime
}

export default useSubmitCountdown
